import Vue from "vue";

const readScaleWeight = (imageFile) => {
  const formData = new FormData();
  formData.append("file", imageFile, imageFile.name || "scale.jpg");
  return Vue.axios.post("/scaleOcr/read", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 20000,
  });
};

export { readScaleWeight };
